<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      v-for="(ticket, index) in tickets"
      :key="index"
    >
      <md-card>
        <md-card-header data-background-color="orange">
          <h4 class="title">
            {{ ticket.from_station_name }}
            <i class="fas fa-chevron-circle-right"></i>
            {{ ticket.to_station_name }}
          </h4>
          <p class="category">{{ ticket.date }}</p>
        </md-card-header>
        <md-card-content>
          <simple-table
            table-header-color="orange"
            :data="ticket.data"
            :fields="fields"
          ></simple-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import SimpleTable from "@/components/Tables/SimpleTable";
import { getTicketFocus, getTicketInfo } from "@/pages/ticket/ticket";

export default {
  name: "Ticket",
  components: {
    SimpleTable
  },
  data() {
    return {
      tickets: [],
      fields: [
        { name: "车次", code: "train_code" },
        {
          name: "出发/到达时间",
          code: "from_time",
          others: ["to_time"],
          filter: (data, other_datas) => data + " / " + other_datas[0]
        },
        { name: "商务座", code: "tz_num" },
        { name: "一等座", code: "ydz_num" },
        { name: "二等座", code: "edz_num" },
        { name: "无座", code: "wz_num" }
      ]
    };
  },
  mounted() {
    this.get_ticket_info();
  },
  methods: {
    get_ticket_info() {
      getTicketFocus().then(res => {
        if (res.data.data) {
          this.tickets = Array.from(res.data.data, x => {
            x.data = [];
            return x;
          });
          for (let ticket of this.tickets) {
            let param = {
              target_date: ticket.date,
              from_station: ticket.from_station,
              to_station: ticket.to_station
            };
            getTicketInfo(param).then(ticket_res => {
              ticket.data = ticket_res.data.data;
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
